import { usePrintData } from '@/core/composables/use-print-data'
import type { FeedbackTopicType, SkillVisualization } from '@/core/models/feedback-topic'
import type { Member } from '@/core/models/member/member'
import type { Perspective } from '@/core/models/perspective'
import type { Skill } from '@/core/models/skill'
import type { EvaluationAnalysis, PulseAnalysis } from '@/core/models/surveys-analytics'
import type { JournalAnalysis } from '@/modules/dialog/composable/use-prepare-journal-slide'

export function usePrintCoacheeProfile() {
  return usePrintData<PrintProfile>({
    loadMockData: async () => {
      const mockData = await import('@/assets/test-data/print-profile.test-data')
      return mockData.printProfileTestData
    },
  })
}

type PrintProfileSlide =
  | {
      type: FeedbackTopicType.Journal
      feedbackTopic: {
        id: string
        title: string
        icon: string
      }
      analysis: JournalAnalysis
    }
  | {
      type: FeedbackTopicType.Evaluation
      feedbackTopic: {
        id: string
        title: string
        icon: string
        showBlindspots: boolean
        skillVisualization: ReadonlyArray<SkillVisualization>
        perspectives: ReadonlyArray<Perspective>
        includeSelf: boolean
      }
      analysis: EvaluationAnalysis
    }
  | {
      type: FeedbackTopicType.Pulse
      feedbackTopic: {
        id: string
        title: string
        icon: string
        perspectives: ReadonlyArray<Perspective>
        includeSelf: boolean
      }
      analysis: PulseAnalysis
    }

export interface PrintProfile {
  organizationName: string
  member: Member
  memberAvatar: string | null
  superpower: Skill | null
  slides: ReadonlyArray<PrintProfileSlide>
}
